/* eslint-disable */

import { useState, useContext, useEffect, useCallback, Suspense } from "react";
import AlertSubscriptionGrid from "./alertSubscriptionGrid/AlertSubscriptionGrid";
import UIContext from "../../../../contexts/UIContext/UIContext";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import TabPanel from "../../../shared/tabPanelComponent/TabPanel.jsx";

import { Box, Tab, Tabs, useMediaQuery } from "@material-ui/core";

import EmailIcon from "@material-ui/icons/Email";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import { User } from "../../../../@types/user.types";
import { PaginationQuery, PaginationTypes } from "../../../../@types/pagination.types";

import axios from "axios";
import { port, url } from "../../../../config/config";
import { Pagination } from "@material-ui/lab";
import { api } from "../../../../utils/api/index";
import a11yProps from "../../../../constants/tabPanelProps/ayProps";
import getLimit from "../../../../utils/pagination/getLimit";
import useRouteParam from "../../../../hooks/useRouteParam";
import { useSearchParams } from "react-router-dom";
import { useEmployerRoute } from "../../../../hooks";
import { AuthContext } from "../../../../contexts";
import { getPermissionsFromGroupOwner } from "../../../../utils/getPermissionsFromGroupOwner";
import { FormControl, InputAdornment, InputLabel, MenuItem, Select } from "@mui/material";
import BlockIcon from "@material-ui/icons/Block";

const AlertSubscriptionManagement = () => {
	const [payloadForEmailOrNotifications, setPayloadForEmailOrNotifications] = useState<any[]>([]);
	const [groupOwners, setGroupOwners] = useState<User[]>([]);
	const [value, setValue] = useState<number>(0);
	const [searchParams] = useSearchParams();
	const gn = searchParams.get("gn");
	const [limit, setLimit] = useState<number>(5);

	const [tabs, setTabs] = useState<any[]>([]);
	const [pagination, setPagination] = useState<PaginationTypes>({
		currentPage: 1,
		pageCount: undefined
	});
	const [groupNumber, setGroupNumber] = useState<any>(null);
	const { setDashboardHeader } = useContext(UIContext);
	const xl = useMediaQuery("(min-width:1600px)");
	const lg = useMediaQuery("(min-width:1200px)");
	const md = useMediaQuery("(min-width:800px)");
	const sm = useMediaQuery("(min-width:600px)");
	const xs = useMediaQuery("(min-width:400px)");
	const _limit = getLimit(xl, lg, md, sm, xs);

	const isEmployerRoute = useEmployerRoute();

	const { user, setUser } = useContext(AuthContext);

	// const permission = (user as any)?.permissions.filter((permission: any) => permission.group_number === 0);
	// const documentSharingPermission =
	// 	permission && permission.length > 0
	// 		? permission[0]?.permission_and_subscription.permissions.settings_menu.document_sharing_sub.self
	// 		: null;

	const alertSubscriptionsPermission =
		user && isEmployerRoute && gn
			? getPermissionsFromGroupOwner(user, Number(gn))?.employer_settings_menu.alert_subscription_sub.self
			: user
			? getPermissionsFromGroupOwner(user, 0)?.settings_menu.alert_subscription_sub.self
			: null;

	// console.log(JSON.stringify(alertSubscriptionsPermission), "alertSubscriptionsPermission");

	// eslint-disable-next-line @typescript-eslint/ban-types
	const handleLabelChange = (event: React.ChangeEvent<{}>, newValue: any) => {
		setValue(newValue as number);
	};

	const handleTabRenders = useCallback(() => {
		const tabs: any[] = [];

		if (groupNumber == null || groupNumber == undefined) {
			return;
		}

		groupOwners.forEach((groupOwner: any) => {
			const permission = groupOwner.permissions.filter((assignedGroupPermission: any) => {
				if (assignedGroupPermission.group_number == groupNumber) return true;
				return false;
			});
			// console.log(groupNumber, "perm", permission[0]);
			groupOwner["subscription"] = permission[0]["permission_and_subscription"]["subscription"];
		});
		if (alertSubscriptionsPermission?.email_tab?.view) {
			tabs.push({
				label: (
					<div>
						<EmailIcon style={{ verticalAlign: "middle" }} className="glb-tab-icon" />
						Email
					</div>
				),
				component: (
					<AlertSubscriptionGrid
						gridProps={groupOwners || []}
						setGridProps={setGroupOwners}
						permission={alertSubscriptionsPermission.email_tab}
						tabValue="email"
						getGroupOwners={getGroupOwners}
						groupNumber={groupNumber}
						payloadForEmailOrNotifications={payloadForEmailOrNotifications}
						setPayloadForEmailOrNotifications={setPayloadForEmailOrNotifications}
					/>
				)
			});
		}

		if (alertSubscriptionsPermission?.notification_tab?.view) {
			tabs.push({
				label: (
					<div>
						<NotificationsActiveIcon style={{ verticalAlign: "middle" }} className="glb-tab-icon" />
						Notification
					</div>
				),
				component: (
					<AlertSubscriptionGrid
						gridProps={groupOwners || []}
						setGridProps={setGroupOwners}
						tabValue="notification"
						permission={alertSubscriptionsPermission.notification_tab}
						getGroupOwners={getGroupOwners}
						groupNumber={groupNumber}
						payloadForEmailOrNotifications={payloadForEmailOrNotifications}
						setPayloadForEmailOrNotifications={setPayloadForEmailOrNotifications}
					/>
				)
			});
		}
		setTabs(tabs);
	}, [alertSubscriptionsPermission, groupOwners, groupNumber]);

	const getGroupOwners = useCallback(async () => {
		// if (typeof limit === "number" && typeof pagination.currentPage === "number") {
		// 	// console.log("Get Groups Inside2");
		// 	const paginationQuery: PaginationQuery = {
		// 		page: pagination.currentPage,
		// 		limit
		// 	};
		// 	const response = await axios.get(`${url}:${port}/api/v1/user/group-owners/paginated`, {
		// 		params: paginationQuery,
		// 		headers: {
		// 			Authorization: `Bearer ${localStorage.getItem("@jwt")}`
		// 		}
		// 	});
		// 	setGroupOwners(Object.assign([], response.data.result));
		// }
		try {
			if (groupNumber !== null && groupNumber !== undefined) {
				const paginationQuery: PaginationQuery = {
					page: 1,
					limit: 1000,
					group_number: groupNumber
				};
				const response = await axios.get(`${url}:${port}/api/v1/user/group-owners/paginated`, {
					params: paginationQuery,
					headers: {
						Authorization: `Bearer ${localStorage.getItem("@jwt")}`
					}
				});

				// console.log("updated value checked", response.data.result);
				setGroupOwners(Object.assign([], response.data.result));
			}
			// handleTabRenders();
		} catch (Err) {
			alert("No Group Owners found in this group or something went wrong");
		}
	}, [groupNumber]);

	const getGroupOwnerCount = useCallback(async () => {
		if (limit) {
			const groupOwnerCount = await api.groupOwner.getGroupOwnerCount();
			const _pageCount = Math.ceil(groupOwnerCount / limit);
			setPagination(
				Object.assign({}, pagination, {
					pageCount: _pageCount
				})
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [limit]);

	const handlePageChange = useCallback(
		(event: React.ChangeEvent<unknown>, value: number) => {
			setPagination(
				Object.assign({}, pagination, {
					currentPage: value
				})
			);
		},
		[pagination]
	);
	const handleChange = (event: any) => {
		// console.log("object", event.target.value);
		setGroupNumber(event.target.value);
	};

	// console.log("object", alertSubscriptionsPermission);
	useEffect(() => {
		// setLimit(_limit);
		getGroupOwnerCount();
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.email_notification_managements);
	}, [getGroupOwnerCount, setDashboardHeader]);

	useEffect(() => {
		if (limit && pagination.pageCount && groupNumber != null && groupNumber != undefined) {
			getGroupOwners();
		}
	}, [pagination, limit, getGroupOwners, groupNumber]);

	useEffect(() => {
		if (groupOwners && groupOwners.length > 0) {
			handleTabRenders();
		}
	}, [groupOwners]);

	// const { currentPage, pageCount } = pagination;

	useEffect(() => {
		if (isEmployerRoute && gn) {
			setGroupNumber(Number(gn));
		}
	}, [isEmployerRoute, gn]);

	return (
		<div className="alert-subscription-container">
			<Box sx={{ width: "100%" }}>
				<Box>
					<FormControl variant="outlined" sx={{ m: 1, mx: "0", minWidth: "200px" }}>
						<InputLabel id="demo-simple-select-label">Group Number</InputLabel>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={groupNumber == 0 || groupNumber ? groupNumber : ""}
							disabled={isEmployerRoute ? true : false}
							startAdornment={
								isEmployerRoute && (
									<InputAdornment
										position="start"
										sx={{
											opacity: 0, // hidden by default
											transition: "opacity 0.2s ease-in-out",
											".MuiOutlinedInput-root:hover &": {
												opacity: 1 // show only on hover
											}
										}}
									>
										<BlockIcon />
									</InputAdornment>
								)
							}
							label="Group Number"
							onChange={handleChange}
						>
							{user &&
								(user as any).permissions.map((permission: any) => {
									if (permission.group_number === 0) {
										return (
											<MenuItem key={permission.permission_id} value={permission.group_number}>
												{"Super Admin"}
											</MenuItem>
										);
									} else {
										return (
											<MenuItem key={permission.permission_id} value={permission.group_number}>
												{permission.group_number}
											</MenuItem>
										);
									}
								})}
							{/* <MenuItem value={0}>0 - super admin</MenuItem>
							<MenuItem value={220}>220 - Brookshire Brothers</MenuItem>
							<MenuItem value={300}>300 - Some Other Group</MenuItem> */}
						</Select>
					</FormControl>
				</Box>

				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					{groupNumber === null && (
						<div style={{ color: "red", fontSize: "16px" }}> please select group number first</div>
					)}

					{tabs.length > 0 && (
						<Tabs
							value={value}
							onChange={handleLabelChange}
							aria-label="basic tabs example"
							TabIndicatorProps={{
								style: {
									border: "none",
									backgroundColor: "#558b2f"
								}
							}}
							className="glb-tab-panel"
						>
							{tabs.map((tab, idx) => (
								<Tab key={idx} label={tab.label} className="glb-tab-label" {...a11yProps(idx)} />
							))}
						</Tabs>
					)}
				</Box>

				{tabs.length > 0 &&
					tabs.map((tab, idx) => (
						<TabPanel key={idx} value={value} index={idx}>
							{tab.component}
						</TabPanel>
					))}
			</Box>
		</div>
	);
};

export default AlertSubscriptionManagement;
